<script setup lang="ts">
import { computed, onMounted, PropType, ref, watch } from "vue";
import { OptionItemModel } from "../../../models";
import { TirPmSvg } from "tir-components";

/**Параметры */
const props = defineProps({
  /**Данные опции фильтра */
  item: {
    type: Object as PropType<OptionItemModel>,
    required: true,
  },
});
/**Ссылка на дом элемента фильтра */
const $itemFilter = ref<InstanceType<typeof HTMLElement>>();

/**После рендера компонента */
onMounted(() => {
  props.item.Width = $itemFilter.value?.offsetWidth;
});
</script>
<template>
  <div ref="$itemFilter" class="filter-parameter-namespaces__item">
    <TirPmSvg :url="item.Icon" :color="item.Color" class="filter-parameter-namespaces__icon" />
    <div class="filter-parameter-namespaces__name">
      {{ item.Name }}
    </div>
  </div>
</template>
<style scoped lang="scss">
.filter-parameter-namespaces {
  &__item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  &__icon {
    width: 1.5rem !important;
    height: 1.5rem !important;
  }

  &__popover-content {
    padding: 0.75rem;
  }

  &__name {
    font-size: 0.875rem;
    font-weight: 500;
    text-transform: uppercase;
  }
}
</style>
<style lang="scss">
.filter-parameter-namespaces__icon .tir-pm-svg__content {
  width: 1.125rem !important;
  height: 1.125rem !important;
}
</style>
